import { render, staticRenderFns } from "./CriteriaAssessmentRubic.vue?vue&type=template&id=72be2cc9&scoped=true&"
import script from "./CriteriaAssessmentRubic.vue?vue&type=script&lang=js&"
export * from "./CriteriaAssessmentRubic.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaAssessmentRubic.vue?vue&type=style&index=0&id=72be2cc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72be2cc9",
  null
  
)

export default component.exports